import { inject, Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, Data, Resolve, RouterStateSnapshot } from "@angular/router";
import { LoadingService } from "@core/loading.service";
import { firstValueFrom } from "rxjs";
import { StoreRepositoryService } from "../pages/store/store-repository.service";
import { findKnownStoreProduct, StoreKnownProductName } from "../pages/store/store-known-products";
import { ProductService } from "./product.service";

@Injectable()
export class StoreDataResolverService implements Resolve<any> {
  private storeService = inject(StoreRepositoryService);
  private loadingService = inject(LoadingService);
  private productService = inject(ProductService);

  async resolve(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<Data | null> {
    const productParam = route.params?.product;

    if (!productParam) {
      return null;
    }

    const productName = this.findProductName(productParam);

    if (!productName) {
      return null;
    }

    this.storeService.selectedProduct$.next(productName);
    await this.loadingService.present();

    try {
      const data = await firstValueFrom(this.productService.fetchProductData(productName));
      this.storeService.selectedProductData$.next(data);
      return data;
    } catch {
      return null;
    } finally {
      this.loadingService.dismiss();
    }
  }

  private findProductName(urlParam: string): StoreKnownProductName | null {
    return findKnownStoreProduct(urlParam);
  }
}